import './media.scss';

import { faImage } from '@fortawesome/free-regular-svg-icons';
import { faTabletAlt } from '@fortawesome/free-solid-svg-icons';
import { faCircleNotch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Component, Watch } from 'vue-property-decorator';

import { Item, itemSelectors } from '@skinsoft/entity';
import { getImageOrientation, MediaTransferHelper } from '@skinsoft/media-transfer-helper'
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { isImageOrientationAutoManaged } from '@skinsoft/utils'

@Component({
    props: ['item', 'mediaId', 'onlyInCache'],
    template: require('./media.html'),
})
export class Media extends ReactiveVue {
    public item: Item;
    public mediaId: string;
    public onlyInCache: boolean;

    public media: string = null as any;
    public loadingIcon = faCircleNotch;
    public errorIcon = faTimes;
    public error = false;
    public pending = false;

    // Icons
    public mediaIcon = faImage;
    public localIcon = faTabletAlt;

    public $mediaTransferHelper: MediaTransferHelper;

    public orientationClass: string = "";
    public $refs: {
        img: any;
    };

    private fileSource: string = "";

    public mounted() {
        this.fetchMedia()
    }

    private isMediaLocal() {
        return this.media && this.fileSource === "cache";
    }

    private fetchMedia() {
        const mediaId = this.item !== undefined ? itemSelectors.media(this.item) : this.mediaId;
        if (mediaId) {

            // If mediaId is set to loading, display a forever spinning media
            if (mediaId === "loading") {
                this.pending = true;
            } else {
                this.pending = true;

                this.subscribeTo(this.$mediaTransferHelper.downloadMedia(mediaId, 'vignette250', this.onlyInCache),
                    media => {
                        this.media = media.dataUrl;
                        this.fileSource = media.source;
                        this.pending = false;
                        if (media.newMediaId) {
                            // Notifying parent that the media id has changed, from a backend operation
                            this.$parent.$emit('id-changed-from-cache', { oldMediaId: mediaId, newMediaId: media.newMediaId })
                            this.unsubscribeFrom('media')
                        }else if(mediaId.startsWith('local:') && media.dataUrl === undefined) {
                            //Try to search image from filename
                            this.$mediaTransferHelper.findMediaIdFromFileName(mediaId.substring(mediaId.indexOf(':') + 1))
                        }
                    },
                    'media',
                );
            }
        }
    }

    private async getRotateClass() {
        this.$refs.img.onload = async () => {
            let orientation = 1;
            orientation = isImageOrientationAutoManaged() ? 1 : await getImageOrientation(this.$refs.img)
            switch (orientation) {
                case 3:
                    this.orientationClass = "rotate180"
                    break;
                case 6:
                    this.orientationClass = "rotate90"
                    break;
                case 8:
                    this.orientationClass = "rotateM90"
                    break;
                default:
                    this.orientationClass = ""
                    break;
            }
        }
    }

    @Watch('item')
    private onItemChange(item) {
        this.unsubscribeFrom('media');
        this.fetchMedia();
    }

    @Watch('mediaId')
    private onMediaChange(media) {
        this.fetchMedia();
    }

    @Watch('media')
    private onMediaReady(media) {
        this.getRotateClass();
    }
}
